import { Component, OnInit, Output, EventEmitter, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UserLogin } from "../../models";
import { Token } from "../../models/token";
import { UserAuthenticationService } from "../../services/shared";
import {NgProgressService} from "ng2-progressbar";
import * as swal                from "sweetalert2";
import { CONFIGURATION } from "../../app.constants";

@Component({
    selector: "gateway-component",
    template: require("./gateway.component.html")
})

export class GatewayComponent implements OnInit {
    @Output() handleProcessing: EventEmitter<any> = new EventEmitter();
    userLogin: UserLogin;
    errorMessage: string;
    isProcessing: boolean;
    loginAttempts: number = 0;
    private ssoExchangeStarted: boolean = false;

    

    constructor(private userAuthService: UserAuthenticationService, private cecRouter: Router, 
        private pService: NgProgressService, private activatedRoute: ActivatedRoute) {

        activatedRoute.queryParams.subscribe(params => {
            const userId = params['userId'];

            if (this.ssoExchangeStarted) {
                return;
            }

            if (!userId || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(userId)) {
                this.errorMessage = "Your single sign-on session is invalid or has expired. Please sign in again.";
                return;
            }

            this.ssoExchangeStarted = true;
            window.history.replaceState(null, document.title,
                window.location.pathname + window.location.hash.split("?")[0]);
            this.userLogin = new UserLogin();
            this.userLogin.userName = userId;
            this.userLogin.password = userId;
            this.isProcessing = false;
            this.DoUserLogin();
        });

    }

    public ngOnInit() {
        if (this.userAuthService.isAuthenticated) {
            this.cecRouter.navigate(["/myhome"]);
        }
    }

    public DoUserLogin(): void {
        this.pService.start();
        this.isProcessing = true;
        this.handleProcessing.emit(true);
        this.errorMessage = "";

        this.userAuthService
            .LoginSSO(this.userLogin.userName, this.userLogin.password)
            .subscribe(
            (response: Token) => {
                this.cecRouter.navigate(["/myhome"]);
            },
            (error) => {
                this.loginAttempts += 1;
                let errorObject = JSON.parse(error._body);
                if (errorObject.error === "sso_session_expired") {
                    this.errorMessage = errorObject.error_description;
                    swal({
                        title: "Single sign-on session expired",
                        text: errorObject.error_description,
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonText: "Sign in again"
                    }).then(()=> {
                        window.location.href = CONFIGURATION.baseUrls.cloudUi;
                    });
                } else if (errorObject.error === "pending_account") {
                    swal({
                        title: "Pending Account",
                        text: errorObject.error_description,
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonText: "Ok"
                    }).then(()=> {
                        this.cecRouter.navigate(["/logout"]);
                    });
                } else if (errorObject.error === "invalid_credentials") {
                    swal({
                        title: "Account Credentials",
                        text: errorObject.error_description,
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonText: "Ok",
                    }).then(()=> {
                        this.cecRouter.navigate(["/logout"]);
                    });
                } else {
                    
                    this.errorMessage = errorObject.error_description;
                    swal({
                        title: "Unexpected error",
                        text: errorObject.error_description,
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonText: "Ok",
                    }).then(()=> {
                        this.cecRouter.navigate(["/logout"]);
                    });
                }

            }).add(c => {
                this.isProcessing = false;
                this.pService.done();
                this.handleProcessing.emit(false);
            });
    }

    public onHandleProcessing(isProcessing) {
        this.isProcessing = isProcessing;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/gateway/gateway.component.ts